import { render, staticRenderFns } from "./UntBuyLine.vue?vue&type=template&id=22a71fb6&scoped=true"
import script from "./UntBuyLine.vue?vue&type=script&lang=js"
export * from "./UntBuyLine.vue?vue&type=script&lang=js"
import style0 from "./UntBuyLine.vue?vue&type=style&index=0&id=22a71fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a71fb6",
  null
  
)

export default component.exports